import { type ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'

export interface EditUserInformationDialogProps {
  showing: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitPending: boolean
  /**
   * The form fields.
   */
  children: ReactNode
}

export function EditUserInformationDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  children,
}: EditUserInformationDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle>Edit user information</ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <ModalSheetSection spaced>
          <form onSubmit={onSubmit}>{children}</form>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Save"
            type="submit"
            variant="primary"
            testId="edit-user-information-save-button"
            onPress={onSubmit}
            isPending={isSubmitPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
